define('presentation/settings/liveReceptionistScripts/validators/liveReceptionistScriptCallControlsTabViewModelValidator',[
    'constants/liveReceptionistScriptTypeConstants',
    'presentation/common/validation/commonValidator',
    'presentation/common/validation/validationRule'
], function () {
    return function () {
        const self = this;

        let _liveReceptionistScriptCallControlsTabViewModel;
        let _liveReceptionistScriptCallControlsTabFacade;

        const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
        const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

        const LiveReceptionistScriptTypeConstants = require('constants/liveReceptionistScriptTypeConstants');

        let _commonValidator = null;

        self.registerViewModel = (liveReceptionistScriptCallControlsTabViewModel, liveReceptionistScriptCallControlsTabFacade) => {
            _commonValidator = new CommonValidatorConstructor(liveReceptionistScriptCallControlsTabViewModel);

            const validationRules = new ValidationRulesConstructor();

            validationRules.field("queueId")
                .addValidationI18n(_validateQueueId, 'addLiveReceptionistScript:queueIdRequired');

            _liveReceptionistScriptCallControlsTabViewModel = liveReceptionistScriptCallControlsTabViewModel;
            _liveReceptionistScriptCallControlsTabFacade = liveReceptionistScriptCallControlsTabFacade;

            _commonValidator.useManualValidation();
            _commonValidator.setValidationRules(validationRules);
        };

        self.validate = () => {
            return _commonValidator.validate();
        };

        const _validateQueueId = (queueId) => {
            const selectedScriptType = _liveReceptionistScriptCallControlsTabViewModel.selectedType();
            if (selectedScriptType === LiveReceptionistScriptTypeConstants.OutboundCalling.toString()) {
                return true;
            }

            return _commonValidator.isStringWithValue(queueId);
        };
    };
});

